import React from 'react'

class SearchMarker extends React.Component {

}

export default SearchMarker